export const packageType = {
    OneDayTrip: "OneDayTrip",
    Transfer: "Transfer",
    Ferries: "Ferries",
    Service: "Service",
};